import { zodResolver } from '@hookform/resolvers/zod';
import { useForm } from 'react-hook-form';
export const useBosForm = (schema, params) => {
    return useForm({
        ...params,
        resolver: zodResolver(schema),
    });
};
